// extracted by mini-css-extract-plugin
export default {"CustomerId":"_CustomerId--zp1_G","Label":"_Label--znhB4"};